/* eslint-disable @typescript-eslint/no-explicit-any */
import { find as _find } from 'lodash';
import { useQuery } from '@apollo/client';
export const useFetchItems = ({ spec, fetchQuery, dataProp, skip, fetchPolicy, }) => {
    let variables;
    if (spec) {
        variables = { spec };
    }
    const { data, loading, error, refetch } = useQuery(fetchQuery, {
        variables,
        skip,
        fetchPolicy,
    });
    const items = data ? data[dataProp] : undefined;
    const find = (id) => _find(items, item => item.id === id);
    return {
        items,
        loading,
        error,
        find,
        refetch,
    };
};
